/**
 * Single source of truth for dashboard API origin.
 * Use Cloud Run when your PC cannot reach BigQuery (VPN/network): set REACT_APP_API_URL and REACT_APP_SKIP_AUTH=false.
 */
const CLOUD_RUN_API =
  'https://pos-data-pipeline-447268935368.asia-northeast1.run.app/api/v1';

/**
 * Cloud Run revision tag: the frontend's `stg---…run.app` URL talks to the backend's
 * `stg---` revision. Decided at runtime so the SAME image is tested on staging and then
 * promoted to prod (deploy-staging.sh / promote-staging.sh) — nothing is rebuilt.
 */
function withStagingTag(base) {
  if (typeof window === 'undefined' || !window.location.hostname.startsWith('stg---')) return base;
  try {
    const u = new URL(base);
    if (!u.hostname.endsWith('.run.app') || u.hostname.startsWith('stg---')) return base;
    u.hostname = `stg---${u.hostname}`;
    return u.toString().replace(/\/$/, '');
  } catch {
    return base;
  }
}

export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return withStagingTag(String(process.env.REACT_APP_API_URL).replace(/\/$/, ''));
  }
  if (typeof window === 'undefined') {
    return 'http://localhost:8000/api/v1';
  }
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') {
    return 'http://localhost:8000/api/v1';
  }
  return withStagingTag(CLOUD_RUN_API);
}

/** True only when calling local backend without Bearer (needs backend SKIP_AUTH_FOR_DEV). */
export function shouldSkipBearerToken() {
  if (process.env.REACT_APP_SKIP_AUTH !== 'true') return false;
  try {
    const u = new URL(getApiBaseUrl());
    return u.hostname === 'localhost' || u.hostname === '127.0.0.1';
  } catch {
    return false;
  }
}
